export const isObject = (el) => el && el.constructor.name === 'Object'
